export const getIconUrlByTag = (icons, tag) => {
  var _icons$find, _icons$find2;
  const iconUrlByTag = icons == null || (_icons$find = icons.find(icon => icon.tag === tag)) == null || (_icons$find = _icons$find.image) == null ? void 0 : _icons$find.url;
  const defaultIconUrl = icons == null || (_icons$find2 = icons.find(icon => icon.format === 'SVG' && !icon.tag)) == null || (_icons$find2 = _icons$find2.image) == null ? void 0 : _icons$find2.url;
  return iconUrlByTag || defaultIconUrl;
};
//# sourceMappingURL=getIconUrlByTag.js.map